const style = {
  mapWrapper: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    padding: 0,
    position: 'relative',
    borderRadius: '5px 5px 0 0',
    boxShadow: '-3px -3px 6px 0px rgb(34 60 80 / 20%)',
  },
  mapHeader: {
    background: '#FFFFFF',
    width: '100%',
    height: '40px',
    position: 'absolute',
    top: 0,
    zIndex: 2,
    borderRadius: '5px 5px 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',

    '& > div': {
      display: 'flex',
    },
  },
  mapLoading: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: 'rgba(0,0,0,0.6)',
    top: 0,
    zIndex: 99999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '18px',
  },
  mapControlsWrapper: {
    '& > svg': {
      width: '60px',
    },
    '& svg:nth-child(2n)': {
      borderLeft: '1px solid #BFBFBF',
      borderRight: '1px solid #BFBFBF',
    },
  },
  selectedCitiesList: {
    display: 'flex',
    marginTop: '16px',
  },
  selectedCity: {
    marginRight: '8px',
    padding: '4px 12px',
    border: '1px solid #BDBDBD',
    borderRadius: '6px',
    background: '#FFFFFF',
    cursor: 'pointer',
  },
  mr_8: {
    marginRight: '8px',
  },
  activeUndoRedo: {
    cursor: 'pointer',
  },

  zoneType: {
    fontSize: '14px',
  },
}

export default style
